export enum NewDesignerRequestControlName {
  ConnectionAndNetworkGroup = 'ConnectionAndNetworkGroup',
  ConnectionAndNetworkGroupArray = 'connectionAndNetworkGroupArray',
  CouncilSubject = 'councilSubject',
  EmailingConsent = 'emailingConsent',
}
